// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Views
import NotFound from "views/NotFound/application";
import Users from "views/Users/application/user";
import Billing from "views/Billing/application";
import Integrations from "views/Integrations/application/integrations";

class RouteApp extends Component {
  handleComponent(type) {
    switch (type) {
      case "billing":
        return <Billing />;
      case "users":
        return <Users />;
      case "integrations":
        return <Integrations />;
      default:
        return <NotFound />;
    }
  }

  render() {
    const { match } = this.props;
    return (
      <div className={"man-content"}>
        {this.handleComponent(match.params.type)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(RouteApp);

export default withRouter(connect_);
